import React from 'react';
import Container from './Container';
import Text from './Text';
import Image from './Image';
import Date from './Date';

export default ({ item }) => (
  <Container>
    <Image src={item.image} />
    <Text>{item.title}</Text>
    <Date>{item.created_at}</Date>
  </Container>
);
